var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 815.0813648293963 811.9711286089239",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l815.08136 0l0 811.9711l-815.08136 0l0 -811.9711z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l815.08136 0l0 811.9711l-815.08136 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    d: "m161.88715 105.54101l0 0c0 -45.224472 36.661667 -81.886154 81.88614 -81.886154l327.53476 0l0 0c21.71759 0 42.545654 8.627268 57.902283 23.9839c15.356628 15.356632 23.983887 36.184692 23.983887 57.902252l0 600.8891c0 45.224487 -36.661682 81.88617 -81.88617 81.88617l-327.53476 0c-45.224472 0 -81.88614 -36.661682 -81.88614 -81.88617z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m161.88715 105.54101l0 0c0 -45.224472 36.661667 -81.886154 81.88614 -81.886154l327.53476 0l0 0c21.71759 0 42.545654 8.627268 57.902283 23.9839c15.356628 15.356632 23.983887 36.184692 23.983887 57.902252l0 600.8891c0 45.224487 -36.661682 81.88617 -81.88617 81.88617l-327.53476 0c-45.224472 0 -81.88614 -36.661682 -81.88614 -81.88617z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e06666",
    d: "m407.54068 323.33466c67.2113 -188.1916 329.3353 0 0 241.96063c-329.3353 -241.96063 -67.21127 -430.15222 0 -241.96063z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartCard);
export default __webpack_public_path__ + "static/media/heart-card.4a4907053762f58b7be9f62505944d25.svg";
export { ForwardRef as ReactComponent };